(() => {
  class ScanwellMatchingFormController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, $state, ngDialog, Utils, Orders, Notifications) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        $state,
        ngDialog,
        Utils,
        Orders,
        Notifications,
        result: $scope.ngDialogData.result,
        oldResult: angular.copy($scope.ngDialogData.result)
      });
      $scope.$on('ngDialog.opened', function (e, $dialog) {
        $(".ngdialog-theme-default.scanwell-matching-form-modal").children(".ngdialog-content").draggable({
          handle: ".scanwell-handler"
        });
      }); // this.scanwellMatchingStatuses = [
      //   { value : "New", description : "New"},
      //   { value : "Unmatched", description : "Unmatched"},
      //   { value : "Matched", description : "Matched"},
      //   { value : "No Match Found", description : "No Match Found"},
      //   { value : "Duplicate", description : "Duplicate"}
      // ];

      this.scanwellMatchingStatuses = [{
        value: "Update Status",
        description: "Update Status"
      }, {
        value: "Matched",
        description: "Matched"
      }, {
        value: "No Match Found",
        description: "No Match Found"
      }];
      this.new_status = "Update Status";
      this.getDetails();
    } // checkNewStatus(newStatus, oldStatus) {
    //   if (newStatus != 'Matched' && newStatus != 'No Match Found') {
    //     this.result.status = oldStatus;
    //     this.toastr.warning("Status can only be changed to 'Matched' or 'No Match Found'.");
    //   }
    // }


    close() {
      this.$scope.closeThisDialog(null);
    }

    getDetails() {
      this.Orders.getScanwellMatchingDetails(this.result.id).then(({
        data
      }) => {
        this.result = data;
        this.oldResult = angular.copy(data);
      }).catch(err => {
        // THIS IS THE WAY TO DISPLAY ERRORS FOR GO ENDPOINTS
        if (err && err.data && err.data.error_message) {
          this.toastr.error(err.data.error_message);
        } else {
          this.toastr.error(this.Notifications.generic.failure);
        }
      });
    }

    formReadyToUpdate() {
      if (this.new_status == "No Match Found") {
        return true;
      } else if (this.new_status == "Matched" && this.result.user_id && this.result.order_id) {
        return true;
      } else {
        return false;
      }
    }

    update() {
      if (this.new_status == "Matched" && !this.result.user_id) {
        this.toastr.warning("Please enter MR number.");
        return;
      }

      if (this.new_status == "Matched" && !this.result.order_id) {
        this.toastr.warning("Please enter Visit ID.");
        return;
      }

      const payload = {
        status: this.new_status
      };

      if (this.new_status == "Matched") {
        payload.order_id = parseInt(this.result.order_id);
        payload.user_id = parseInt(this.result.user_id);
      }

      this.Orders.updateScanwellMatchingDetails(this.result.id, payload).then(() => {
        this.toastr.success("Details were updated successfully.");
        var response = {
          success: true
        };
        this.$scope.closeThisDialog(response);
      }).catch(err => {
        // THIS IS THE WAY TO DISPLAY ERRORS FOR GO ENDPOINTS
        if (err && err.data && err.data.error_message) {
          this.toastr.error(err.data.error_message);
        } else {
          this.toastr.error(this.Notifications.generic.failure);
        }
      });
    }

  }

  ScanwellMatchingFormController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "$state", "ngDialog", "Utils", "Orders", "Notifications"];
  angular.module('pims').controller('ScanwellMatchingFormController', ScanwellMatchingFormController);
})();